import { useEffect, useState, useCallback } from 'react'
import { useSessionContext } from '../contexts/SessionContext'
import { logger } from '../utils/helpers/logger'
import { useFeatureFlag } from './authorization'
import { FEATURE_FLAGS } from '../utils/constants/features.constants'
import { AGAMI_INDOOR_BUCKET } from '../utils/constants/db.constants'
import { supabase } from '../utils/helpers/supabase.helpers'
import { BucketFile } from '../types/supabase'

interface UseAgamiIndoorAudioFilesReturn {
  audioFiles: BucketFile[]
  isLoading: boolean
  refetch: () => Promise<void>
}

export const useAgamiIndoorAudioFiles = (): UseAgamiIndoorAudioFilesReturn => {
  const { user } = useSessionContext()
  const agamiIndoorFlag = useFeatureFlag(FEATURE_FLAGS.AGAMI_INDOOR)

  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [audioFiles, setAudioFiles] = useState<BucketFile[]>([])

  const getAllAudioFiles = useCallback(async (): Promise<void> => {
    if (!user) return

    try {
      const { data, error } = await supabase.storage.from(AGAMI_INDOOR_BUCKET).list(`${user.id}/audio`, {
        sortBy: { column: 'name', order: 'asc' },
      })

      if (error) {
        logger.error(error, 'FetchIndoorAudioFiles')
      }

      setAudioFiles(data as unknown as BucketFile[])
    } catch (error) {
      logger.error(error, 'FetchIndoorAudioFiles')
    } finally {
      setIsLoading(false)
    }
  }, [user])

  useEffect(() => {
    if (!agamiIndoorFlag || !user) return
    getAllAudioFiles()
  }, [agamiIndoorFlag, user])

  return {
    audioFiles,
    isLoading,
    refetch: getAllAudioFiles,
  }
}
